import { render, staticRenderFns } from "./PDATest.vue?vue&type=template&id=bd68feb4"
import script from "./PDATest.vue?vue&type=script&lang=js"
export * from "./PDATest.vue?vue&type=script&lang=js"
import style0 from "./PDATest.vue?vue&type=style&index=0&id=bd68feb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports